/** Adding cards actions */
export const REQUEST_ADD_STOP = "dna:request_add_stop";
/** Current stop actions */
export const CURRENT_TOUR_STOP = "dna:current_tour_stop";
export const REQUEST_MORE_TIME = "dna:request_more_time";
export const REQUEST_MOVE_ON = "dna:request_move_on";
export const MORE_TIME_GRANTED = "dna:more_time_granted";
export const SHIFT_CARD = "dna:shift_card";
